import { useContext, useEffect, useState } from 'react'
import { AppContext } from '@state/context'
import useSWR from 'swr'
import { Library_Books } from '@graphql/queries'

const useLibraryBooks = () => {
  const [state] = useContext(AppContext)
  const userId = state?.app?.userId
  const { data, error, mutate, isValidating } = useSWR(Library_Books)
  const [books, setBooks] = useState([])

  useEffect(() => {
    if (data?.libraryBooks?.data) {
      setBooks(data.libraryBooks.data)
    }
  }, [userId, data, isValidating])

  return {
    books,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useLibraryBooks }
